module.exports = __webpack_public_path__ + "img/1289111073.69f58dcb.jpg";